import React from 'react'

import FAQSection from '../Pricing/FAQSection';
import EmailForm from './Email';
import PageLayout from '../PageLayout/PageLayout';

export default function ContactPage() {
  return (
    <div>
      <PageLayout>
        <EmailForm/>
        <FAQSection/>
      </PageLayout>

    </div>

  );
}
